import 'regenerator-runtime';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

export async function addHoneyToUserAccount(scene, amount)
{
	if (scene.userData.uid)
	{
		scene.userData.honey = scene.userData.honey + amount;
		firebase.firestore().collection('users').doc(scene.userData.uid).update({
			honey: scene.userData.honey
		});
		return;
	}
}

export async function addWorkersCreatedToUserAccount(scene)
{
	if (scene.userData.uid)
	{
		scene.userData.workersCreated = scene.userData.workersCreated + 1;
		firebase.firestore().collection('users').doc(scene.userData.uid).update({
			workersCreated: scene.userData.workersCreated
		});
	}
}

export async function addUnlockedLevelToUserAccount(scene, levelUnlocked)
{
	try {
		if (scene.userData.uid)
		{
			firebase.firestore().collection('users').doc(scene.userData.uid).update({
				levelUnlocked: levelUnlocked
			});
			return;
		}
	} catch (e) {
		console.log('There was an error adding unlocked level to user account.', e);
	}
}

export async function getUserData(scene) {
	// Get user account.
	console.log('Getting user data...');
	firebase.firestore().collection('users').doc(scene.uid).get().then(userData => {
		scene.userData = userData.data();
		scene.userData.uid = scene.uid;
		console.log('user data:', userData);
		return userData.data();
	});

}



// WEBPACK FOOTER //
// ./src/modules/userAccounts.js